"use strict";
exports.__esModule = true;
exports.DropdownMenu = void 0;
var DropdownMenu_1 = require("./DropdownMenu");
var DropdownMenuItem_1 = require("./DropdownMenuItem");
var DropdownMenu = Object.assign(DropdownMenu_1.DropdownMenu, { Item: DropdownMenuItem_1.DropdownMenuItem });
exports.DropdownMenu = DropdownMenu;
//# sourceMappingURL=index.js.map